/**
 * @props isPopup: (boolean) - If passed as true, then component will be shown inside a modal
 * @props isPopupOpen: (boolean) - State of opening/closing of modal
 * @props onPopupCloseCb: (callback function) - Callback Function which will get called when the modal is closed
*/

import React, { useEffect, useState } from 'react'
import StepperNavigation from "../../../components/steppernavigation/StepperNavigation"
import GetMethod from './createone/getmethod/GetMethod';
import GetPayerType from './createone/getpayertype/GetPayerType';
import GetBasicInfo from './createone/getbasicinfo/GetBasicInfo';
import GetAddressInfo from './createone/getaddressinfo/GetAddressInfo';
import GetOptionalInfo from './createone/getoptionalinfo/GetOptionalInfo';
import styles from "./AddPayerCommonStyles.styles"
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, setAddressInformation, setAddressInformationFieldsTouched, setBasicInformation, setBasicInformationFieldsTouched, setMethodType, setOptionalInformationFieldsTouched, setPayerCreationSuccessful, setPayerType } from './AddPayerSlice';
import { CHOOSE_METHOD_CARD_NAMES } from './createone/getmethod/constants/constants';
import UploadFile from './bulkupload/uploadfile/UploadFile';
import { addSinglePayer } from './AddPayerSaga';
import Loadable from '../../../components/loadable/Loadable';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import GeneralValidator from '../../../../libs/utility/validators/GeneralValidator';
import { getTemplate, validateSheetRecords } from './bulkupload/BulkUploadSaga';
import { componentKey as bulkUploadComponentKey, setUploadedFile } from "./bulkupload/BulkUploadSlice"
import BulkUploadSuccess from './bulkupload/bulkuploadsuccess/BulkUploadSuccess';
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import { PAYER_SECTION_ROUTES } from '../../payerssection/constants';
import Popup from '../../../components/popup/Popup';
import { componentKey as authenticationSliceKey } from '../../authentication/AuthenticationSlice';
import { setOptionalInformation } from './AddPayerSlice';
import AddPayerSuccess from './createone/addpayersuccess/AddPayerSuccess';
import { PAYER_TYPE_TITLE } from './createone/getpayertype/constants';
import { VALIDATE_NAME_REGEX, VALIDATE_ZIP_CODE_REGEX } from '../../../../libs/utility/constants';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';
import { INTEGRATION_ROUTES, RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, SPACE_NOT_ALLOWED_IN_CLIENT_ID_TEXT } from '../../constants/constants';
import ConfirmRedirection from './ConfirmRedirection';
import { ADD_PAYER_LOADING_MESSAGE_MAP, ADD_PAYER_LOADING_STATES } from './constant';
import { PermissionReroute, isAccessAllowed, useUserPermissionsInfo } from '../../dashboard/hooks/userHooks';
import { PAGE_PATH, PAGE_PERMISSIONS } from '../../dashboard/constants/constant';
import { componentKey as dataLoaderKey } from '../../loaders/dataloader/DataLoaderSlice';

export default function AddPayer({ isPopup = false, isPopupOpen = false, onPopupCloseCb = () => { }, onFinalSubmitCb = () => { }, is1042SForm = false, payerLabel = "Payer" }) {

    useGarbageCollector(componentKey);

    const navigate = useTxNavigate();
    const dispatch = useDispatch();

    const { signedInUser } = useSelector(state => state[authenticationSliceKey]);
    const addPayerData = useSelector((state) => state[componentKey]);
    const { uploadedFile } = useSelector((state) => state[bulkUploadComponentKey]);
    const { methodType, PayerType, payerCreationSuccessful, addressInformation, loadingState, zipCodeValidationSuccess, basicInfo, optionalInformation, newlyAddedPayer } = addPayerData;
    const { countriesList } = useSelector(state => state[dataLoaderKey]);

    const [refreshStep, setRefreshStep] = useState(0);
    const [confirmRedirection, setConfirmRedirection] = useState(false)
    const [showPopup, setShowPopup] = useState(isPopup);

    const { permissions } = useUserPermissionsInfo();

    useEffect(() => {

        if (Object.keys(permissions).length !== 0) {
            if (Object.keys(permissions).length !== 0 && !isAccessAllowed(PAGE_PERMISSIONS.CREATE_PAYERS, permissions)) {
                setShowPopup(false)
                navigate(`/${PAGE_PATH.PAYER}`)
            }
        }
    }, [permissions])

    useEffect(() => {
        dispatch(setOptionalInformation({
            ClientID: {
                value: "",
                errors: {},
                rules: { required: signedInUser?.IsPayerClient ? true : false, regex: { pattern: RESTRICT_SPACE_AND_SPECIAL_CHARACTERES_REGEX, message: SPACE_NOT_ALLOWED_IN_CLIENT_ID_TEXT } }
            }
        }))

        dispatch(setOptionalInformation({
            DisregardedEntity: {
                value: "",
                errors: {},
                rules: { required: signedInUser?.MultiplePayerLocation ? true : false }
            }
        }))
    }, [])

    useEffect(() => {
        const USA = countriesList?.find(country => country?.Country_code === "US")
        dispatch(setAddressInformation({ PayerCountry: USA }));
    }, []);

    useEffect(() => {
        if (PayerType === PAYER_TYPE_TITLE.BUSINESS) {
            dispatch(setBasicInformation({
                PayerFirstName: {
                    value: "",
                    errors: {},
                    rules: { required: false }
                },
            }));

            dispatch(setBasicInformation({
                PayerMiddleName: {
                    value: "",
                    errors: {},
                    rules: { required: false }
                },
            }));
        } else if (PayerType === PAYER_TYPE_TITLE.INDIVIDUAL) {
            dispatch(setBasicInformation({
                PayerFirstName: {
                    value: "",
                    errors: {},
                    rules: { required: false, regex: { pattern: VALIDATE_NAME_REGEX, message: `A valid ${payerLabel} name should only consist any of A-Z,a-z, 0-9,-,.&' letters and maximum 40 character` } }
                },
            }));
            dispatch(setBasicInformation({
                PayerMiddleName: {
                    value: "",
                    errors: {},
                    rules: { required: false, regex: { pattern: VALIDATE_NAME_REGEX, message: `A valid ${payerLabel} name should only consist any of A-Z,a-z, 0-9,-,.&' letters and maximum 40 character` } }
                },
            }));
        }
    }, [PayerType])

    useEffect(() => {
        if (addressInformation.PayerCountry.value !== "US") {
            dispatch(setAddressInformation({
                PayerState: {
                    label: "",
                    value: "",
                    errors: {},
                    rules: { required: false }
                },
            }));

            dispatch(setAddressInformation({
                PayerZIP: {
                    value: "",
                    errors: {},
                    rules: {}
                }
            }));
        } else if (addressInformation.PayerCountry.value === "US") {
            dispatch(setAddressInformation({
                PayerState: {
                    label: "",
                    value: "",
                    errors: {},
                    rules: { required: true }
                },
            }));

            dispatch(setAddressInformation({
                PayerZIP: {
                    value: "",
                    errors: {},
                    rules: { required: true, regex: { pattern: VALIDATE_ZIP_CODE_REGEX, message: "Please enter a valid ZIP Code. The ZIP Code should only contain numbers" } }
                }
            }));
        }
    }, [addressInformation?.PayerCountry?.value])

    useEffect(() => {
        if (payerCreationSuccessful) {

            if (isPopup) {
                setRefreshStep(0)
                onFinalSubmitCb(newlyAddedPayer);
                onPopupCloseCb();
            }

        }
    }, [payerCreationSuccessful])

    const onCloseRedirectionConfirmPopup = () => {
        dispatch(setMethodType(null))
        setConfirmRedirection(false)
    }

    const GET_METHOD_STEP = {
        title: "Choose Method",
        stepBodyComponent: <GetMethod onCardClickCb={(card) => {
            dispatch(setMethodType(card.name))
            if (card.name === CHOOSE_METHOD_CARD_NAMES.INTEGRATION) {
                navigate(`/${INTEGRATION_ROUTES.IMPORT}`)
            }
        }}
            methodType={methodType} onClickLinkButtonTextCb={() => dispatch(getTemplate())} payerLabel={payerLabel} />,
        ...(!isPopup
            ? {
                backButtonText: "Back",
                prevCb: () => {
                    navigate(`/${PAYER_SECTION_ROUTES.PAYER}`);
                },
            }
            : {}),
        submitButtonText: "Next",
        submitButtonDisabled: methodType ? false : true,
        submitButtonDisabledInfoCb: () => {
            dispatch(addNotifications({ heading: "Please choose a method", message: `To continue, please select how would you like to add your ${payerLabel}s?` }))
        },
        submitCb: () => { },
    }

    const CREATE_ONE_STEPS = [
        {
            title: `Type of ${payerLabel}`,
            stepBodyComponent: <GetPayerType onCardClickCb={(card) => dispatch(setPayerType(card.title))} type={PayerType} is1042SForm={is1042SForm} payerLabel={payerLabel} />,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitButtonDisabled: PayerType ? false : true,
            submitButtonDisabledInfoCb: () => {
                dispatch(addNotifications({ heading: `Please select the type of ${payerLabel}`, message: `To continue, please select the type of ${payerLabel}` }))
            },
            submitCb: () => { },
        },
        {
            title: "Basic Information",
            stepBodyComponent: <GetBasicInfo payerLabel={payerLabel} />,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitButtonDisabled: GeneralValidator.validateRequiredFields(basicInfo) ? true : false,
            submitButtonDisabledInfoCb: () => {
                dispatch(setBasicInformationFieldsTouched(true))
                dispatch(addNotifications({ heading: "Error", message: "Please enter valid data" }))
            },
            submitCb: () => { },
        },
        {
            title: "Address Information",
            stepBodyComponent: <GetAddressInfo />,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitButtonDisabled: GeneralValidator.validateRequiredFields(addressInformation) || !zipCodeValidationSuccess ? true : false,
            submitButtonDisabledInfoCb: () => {
                dispatch(setAddressInformationFieldsTouched(true))

                if (GeneralValidator.validateRequiredFields(addressInformation)) {
                    dispatch(addNotifications({ heading: "Please enter valid data", message: "To continue, please enter the valid address data" }))
                } else if (!zipCodeValidationSuccess) {
                    dispatch(addNotifications({ heading: "Please validate the zip code", message: "To continue, please enter the valid zip code and click on next" }))
                }

            },
            submitCb: () => { },
        },
        {
            title: "Optional Information",
            stepBodyComponent: <GetOptionalInfo payerLabel={payerLabel} />,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitButtonDisabled: GeneralValidator.validateRequiredFields(optionalInformation) ? true : false,
            submitButtonDisabledInfoCb: () => {
                dispatch(setOptionalInformationFieldsTouched(true))
                dispatch(addNotifications({ heading: "Please enter valid data", message: "To continue, please enter the valid data" }))
            },
            submitCb: () => dispatch(addSinglePayer(addPayerData)),
        }
    ]

    const BULK_UPLOAD_STEPS = [
        {
            title: "Upload File",
            stepBodyComponent: <UploadFile />,
            discardCb: () => { },
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitCb: () => dispatch(validateSheetRecords()),
            submitButtonDisabled: !uploadedFile,
            submitButtonDisabledInfoCb: () => {
                dispatch(addNotifications({ heading: "Please upload a file to continue", message: "To continue, please enter the valid data" }))
            },
        },
        {
            title: "Bulk Upload Status",
            stepBodyComponent: <BulkUploadSuccess setRefreshStep={setRefreshStep} payerLabel={payerLabel} />,
            backButtonText: "Back",
            prevCb: () => {
                dispatch(setUploadedFile(null));
                setRefreshStep(1);
            },
            // hideProgressBar: true,
        },
    ]

    let steps = [GET_METHOD_STEP];

    switch (methodType) {
        case CHOOSE_METHOD_CARD_NAMES.CREATE_ONE:
            steps = [GET_METHOD_STEP, ...CREATE_ONE_STEPS];
            break;

        case CHOOSE_METHOD_CARD_NAMES.BULK_UPLOAD:
            steps = [GET_METHOD_STEP, ...BULK_UPLOAD_STEPS];
            break;
    }

    const AddPayerComponent = (
        <div style={styles.payerContainer}>
            <Loadable currentState={loadingState.state} loadingStates={[ADD_PAYER_LOADING_STATES.ADD_SINGLE_PAYER_LOADING, ADD_PAYER_LOADING_STATES.GET_TEMPLATE_LOADING, ADD_PAYER_LOADING_STATES.UPLOAD_FILE_LOADING, ADD_PAYER_LOADING_STATES.VALIDATE_SHEET_RECORD_LOADING]} messageMap={ADD_PAYER_LOADING_MESSAGE_MAP} isNewLoadable={true}>
                {payerCreationSuccessful ? <AddPayerSuccess setRefreshStep={setRefreshStep} /> : <StepperNavigation steps={steps} refreshStep={refreshStep} showTopRowButtons={true} setRefreshStep={(idx) => setRefreshStep(idx)} customStepperBodyContainerStyles={{ height: "auto" }}
                    customFooterBodyContainer={{ marginTop: "10px" }} applyMaxHeightToBodyContainer={"55vh"} />}
            </Loadable>
        </div>
    )

    return (
        <>
            {showPopup ?

                <Popup title={""} onCloseCb={onPopupCloseCb} isPopupOpen={showPopup} customPopupSyles={styles.popupStyles} overlayStyles={styles.popupoOverlay} childrenStyles={styles.popupChildrenStyles}>
                    {AddPayerComponent}
                </Popup>

                :

                AddPayerComponent
            }
            {confirmRedirection ?
                <Popup title={""} onCloseCb={onCloseRedirectionConfirmPopup} isPopupOpen={confirmRedirection} customPopupSyles={styles.popupStyles} overlayStyles={styles.popupoOverlay} childrenStyles={styles.ConfirmRedirectionPopUpStyle}>
                    <ConfirmRedirection />
                </Popup> : null
            }
        </>
    )
}